<div id="scanner-wr">
  <div class="btn-wr">
    @if (isCameraOpen || QRCodeValue) {
      @if (isCameraOpen) {
        <button id="camera-toggle" type="button" class="btn circle-button"
        ></button>
      }
      @if (isCameraOpen && hasFlash) {
        <button id="flash-toggle" type="button" class="btn circle-button" [ngClass]="isFlashOn ? 'flash-off' : 'flash-on'" (click)="toggleFlash()"></button>
      }
    }
  </div>

  <section class="camera-stage">
    <div #uiWrapper class="ui-wr" [class.hide]="!isCameraOpen"></div>

    @if (showCameraState) {
      <div class="camera-state">
        @if (showCameraStartGuide) {
          <section id="splash-screen">
            <div class="gray-card">
              <h2>{{ 'CAMERA_SCANNER.QUICK_GUIDE' | translate }}</h2>
              <ol>
                <li>{{ 'CAMERA_SCANNER.QUICK_GUIDE_STEP_01' | translate }}</li>
                <li>{{ 'CAMERA_SCANNER.QUICK_GUIDE_STEP_02' | translate }}</li>
                <li>{{ 'CAMERA_SCANNER.QUICK_GUIDE_STEP_03' | translate }}</li>
              </ol>
            </div>
            <div class="start-scanning">
              <button type="button" class="btn primary-btn w-100" (click)="toggleCamera()">
                {{ 'CAMERA_SCANNER.BTN_START_SCANNING' | translate }}
              </button>
            </div>
          </section>
        } @else {
          <div class="camera-message">
            <!-- @if (showCameraLoader) { <span class="loader"></span> } -->
            <div class="camera-message-content">
              <p class="camera-message-title">{{ cameraStatusTitle }}</p>
              @if (cameraStatusDescription) {
                <p class="camera-message-description">
                  {{ cameraStatusDescription }}
                </p>
              }
            </div>
            @if (showCameraActionButton || showDismissCameraMessage) {
              <div class="camera-actions">
                @if (showCameraActionButton) {
                  <button type="button" class="btn primary-btn" (click)="openCamera()">{{ cameraActionButtonLabel }}</button>
                }
                @if (showDismissCameraMessage) {
                  <button type="button" class="btn outline-btn" (click)="dismissCameraMessage()">Dismiss</button>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </section>

  <div class="footer-wr">
    @if (isCameraOpen && camerasList.length) {
      <select [value]="selectedCameraId" (change)="onCameraChange($event)">
        <option value="" disabled>
          {{ 'CAMERA_SCANNER.PLACEHOLDER_SELECT_CAMERA' | translate }}
        </option>
        @for (device of camerasList; track device) {
          <option [value]="device.deviceId">
            {{ device.label || 'Camera' }}
          </option>
        }
      </select>
    }
  </div>
</div>
